import { useSortTaskSubTasks, useTaskWithSubTaskDocument } from '@ztechapps/task.common'
import React from 'react'
import { TaskTable } from '../List'
import { TaskListProvider, useTaskListContext } from '../Context'
import { EmptySubTaskList } from './EmptySubTaskList'
import { ShowIf } from '@ztechapps/webui.util'
import isEmpty from 'lodash/isEmpty'
import { useDeleteTaskSubTaskWithConfirm } from './useDeleteTaskSubTaskWithConfirm'
import { DeleteManyTaskButton } from '../DataAction'
import type { Task } from '@ztechapps/common.contract'
import { Stack } from 'react-bootstrap'

/**
 * We use this for the recursive display of task, we call the SubTaskList again inside the TaskListRow
 * @param taskId
 * @param level
 * @constructor
 */
export const SubTaskList = ({ taskId, level }: { taskId: string; level: number }) => {
  const { document, loading: loadingDocument } = useTaskWithSubTaskDocument({ _id: taskId, subscribeToUpdates: true })
  const { components, disabled } = useTaskListContext()

  //the onSort function shoudl be overriden here, because we are dealing with sorting of task.SubTask here
  const [onSort, { loading: sortLoading }] = useSortTaskSubTasks()

  //the onDelete function shoudl be overriden here, because we are dealing with removing of task.SubTask here
  const { onDelete, loading: loadingDelete } = useDeleteTaskSubTaskWithConfirm(taskId)

  const loading = loadingDelete || loadingDocument || sortLoading

  //the foot was overriden here, because we are talking to task.subTasks here
  components.foot = ListFooter

  //override the draggint using task.subTasks
  const onDragSort = ({ oldIndex, newIndex }) => {
    const movedData = document?.subTasks?.[oldIndex] as Task
    const subTaskId = movedData?._id

    onSort({
      taskId,
      subTaskId,
      sortIndex: newIndex,
    })
  }

  //if this was called, then the sub-task will be shown
  const subTaskConfig = {
    enabled: true,
    taskId,
    level: level + 1,
  }

  return (
    <TaskListProvider
      subTaskConfig={subTaskConfig}
      loading={loading}
      tasks={document?.subTasks}
      onDragSort={onDragSort}
      components={components}
      onDelete={onDelete}
      disabled={disabled}
    >
      <div style={{ marginLeft: level === 0 ? 0 : 20 }}>
        <Layout />
      </div>
    </TaskListProvider>
  )
}

const Layout = () => {
  const { tasks } = useTaskListContext()
  const hasSubTasks = !isEmpty(tasks)

  return (
    <>
      <ShowIf condition={!hasSubTasks}>
        <EmptySubTaskList />
      </ShowIf>

      <ShowIf condition={hasSubTasks}>
        <Stack gap={2}>
          <div>
            <DeleteManyTaskButton />
          </div>

          <TaskTable />
        </Stack>
      </ShowIf>
    </>
  )
}

const ListFooter = () => {
  return (
    <tfoot>
      <tr>
        <td colSpan={100} className="p-0  m-0">
          <EmptySubTaskList />
        </td>
      </tr>
    </tfoot>
  )
}
